import { Link, useParams } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal, Eyebrow } from '../components/Shared';
import { policies } from '../data/policies';
import { useSeo } from '../hooks/useSeo';
import { L } from '../i18n/LocaleProvider';

export default function PolicyPage({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const policy = policies[slug];

  useSeo(policy ? { title: policy.seoTitle, description: policy.seoDescription, image: '/brand/techspitze-logo.webp' } : {});

  if (!policy) return <main id="main-content" className="container not-found" data-testid="policy-not-found">
    <h1>Policy not found</h1><Link className="action-button button-primary" to="/">Back to Home ↗</Link>
  </main>;

  return <L><main id="main-content" className="policy-page" data-testid={`policy-page-${slug}`}>
    <section className="container policy-hero">
      <Reveal><Eyebrow id={`policy-eyebrow-${slug}`} dot>{policy.eyebrow}</Eyebrow></Reveal>
      <h1 data-testid="policy-title">{policy.title}</h1>
      <p className="policy-updated" data-testid="policy-updated">Last updated {policy.updated}</p>
      <p className="policy-intro" data-testid="policy-intro">{policy.intro}</p>
    </section>

    <div className="container policy-layout">
      <aside className="policy-toc" aria-label="On this page" data-testid="policy-toc">
        <span className="article-toc-title">On this page</span>
        <nav>{policy.sections.map(section => <a key={section.id} href={`#${section.id}`} data-testid={`policy-toc-${section.id}`}>{section.heading}</a>)}</nav>
      </aside>

      <div className="policy-body" data-testid="policy-body">
        {policy.sections.map(section => <section key={section.id} id={section.id} className="policy-section" data-testid={`policy-section-${section.id}`}>
          <h2>{section.heading}</h2>
          {section.body.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
        </section>)}
        <p className="policy-template-note" data-testid="policy-template-note">This policy is a template prepared for review with legal counsel before launch.</p>
      </div>
    </div>

    <section className="container content-cta" data-testid="policy-cta">
      <div className="content-cta-band glass">
        <div><span className="eyebrow"><span className="eyebrow-line" />QUESTIONS?</span><h2>Talk to a human instead.</h2></div>
        <Link to="/contact" className="action-button button-primary" data-testid="policy-cta-button">Contact us <ArrowUpRight size={17} /></Link>
      </div>
    </section>
  </main></L>;
}
